import { FC } from 'react';
import { INews } from '../../../models/INews';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { STYLE_VARS } from '../../../constants/style-vars';
import { Button } from '../../../components/Button';
import { NavigationService } from '../../../services/navigation';
import { IS_WEB } from '../../../constants/platform';
import { addBase64Prefix } from '../../../services/addBase64Prefix';
import { share_icon } from '../../../assets/base64';
import { FONTS } from '../../../constants';
import { INew } from '../../../types';
import { htmlDecode } from '../../../services/utils/htmlDecode';
import dayjs from 'dayjs';

interface SportNewItemProps {
  item: INew;
}

const fakeData = {
  lorem:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
  image: 'https://kcc.org.hk/wp-content/uploads/2022/11/SC-6-scal11d-1.jpg',
};

const SportNewItem: FC<SportNewItemProps> = ({ item }) => {
  const isDesktop = useIsDesktop();

  if (isDesktop()) {
    return (
      <View style={styles.wrapper}>
        <TouchableOpacity
          onPress={() => {
            NavigationService.push<'SportNewDetail'>('SportNewDetail', {
              id: item.id,
            });
          }}
        >
          {item.thumb && (
            <Image
              source={{ uri: item.thumb }}
              style={{
                width: '100%',
                height: 200,
                resizeMode: 'cover',
              }}
            />
          )}
        </TouchableOpacity>
        <View style={{ padding: 17 }}>
          <View style={{ paddingVertical: 5, marginBottom: 5 }}>
            <Text style={styles.dayTextDesktop}>
              {dayjs(new Date(item.date * 1000)).format('MMM DD, YYYY')}
            </Text>
          </View>
          <View>
            <TouchableOpacity
              onPress={() => {
                NavigationService.push<'SportNewDetail'>('SportNewDetail', {
                  id: item.id,
                });
              }}
            >
              <Text style={styles.title} numberOfLines={2}>
                {item.title}
              </Text>
            </TouchableOpacity>
          </View>
          <View
            style={[styles.horizontalLine, { marginTop: 15, marginBottom: 13 }]}
          />
          <View style={{ marginVertical: 10 }}>
            <Text style={styles.contentText} numberOfLines={4}>
              {htmlDecode(item.content)}
            </Text>
          </View>
          <View
            style={{
              alignSelf: 'flex-start',
              marginTop: 13,
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 5,
            }}
          >
            <Button
              text="READ MORE"
              style={STYLE_VARS.blueButton}
              onPress={() => {
                NavigationService.push<'SportNewDetail'>('SportNewDetail', {
                  id: item.id,
                });
              }}
            />
          </View>
        </View>
      </View>
    );
  }

  return <></>;
};

export default SportNewItem;

const styles = StyleSheet.create({
  wrapper: {
    marginVertical: 20,
    borderColor: STYLE_VARS.fccDarkGrey,
    borderWidth: 0.5,
  },
  title: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 20,
    fontWeight: '500',
    color: STYLE_VARS.textColor,
    textTransform: 'uppercase',
  },
  dayText: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 13,
    fontWeight: '500',
    color: STYLE_VARS.fccDarkerGrey,
    textTransform: 'uppercase',
  },
  dayTextDesktop: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 13,
    fontWeight: '500',
    color: STYLE_VARS.fccDarkerGrey,
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  contentText: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 13,
    fontWeight: '500',
    color: STYLE_VARS.fccDarkerGrey,
    textTransform: 'uppercase',
    textAlign: 'justify',
  },
  horizontalLine: {
    width: 35,
    height: 4,
    backgroundColor: STYLE_VARS.primaryColor,
  },
});
